export default __webpack_public_path__ + "static/media/Lotin-Kirill.6b70bafe.jpg";